export default "__VITE_ASSET__BJvOrlxB__"